import { render, staticRenderFns } from "./ProductReviewView.vue?vue&type=template&id=4fa5b2e5&scoped=true"
import script from "./ProductReviewView.vue?vue&type=script&lang=js"
export * from "./ProductReviewView.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewView.vue?vue&type=style&index=0&id=4fa5b2e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5b2e5",
  null
  
)

export default component.exports